import React, {useState} from 'react';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

//
// const PlusIcon = (props) => (
//   <Icon {...props} name='star' style={{width:100 , height:100}} fill='#000'/>
// );
export const LoginScreen = () => {


  return (
    <ScrollView>
      <Layout style={styles.container} level='2' >

        <Text appearance='hint' style={{margin:40, textAlign:'center', lineHeight:25}}>{width}</Text>
        <Button
          style={{borderRadius:10,marginTop:5, paddingVertical:10, width:width*0.85}}
          onPress={()=>{RootNavigation.navigate('Menu')}}
          >login</Button>
      </Layout>
      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    height: height-30


  },
});
